import AsyncFlow from '../asyncFlow';

export default AsyncFlow({
    store: 'check-SN',
    initialState: {
        is_sn_valid: true,
        statusAction: 'READY',
    },
    actions: ['CHECK_SN'],
}).extend({
    reducer: (state, action, { types }) => {
        switch (action.type) {

            case types.CHECK_SN_SUCCESS:
                return {
                    ...state,
                    is_sn_valid: action.payload.is_sn_valid,
                };

            default:
                return state;
        }
    },
    creators: ({ types }) => ({
        //checkSN
        checkSNRequest: (sn, tipologia) => ({
            type: types.CHECK_SN_REQUEST,
            payload: { sn, tipologia },
        }),
        checkSNSuccess: ({ is_sn_valid }) => ({
            type: types.CHECK_SN_SUCCESS,
            payload: { is_sn_valid },
        }),
        checkSNFailed: error => ({ type: types.CHECK_SN_FAILED, error: true, payload: { error } }),
    }),
});
